<ng-container *transloco="let t; prefix: translocoPrefix">
  <button nz-button nzType="primary" (click)="handleLogout()">
    {{ t('LOGOUT') }}
  </button>
</ng-container>
